import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px } from '@ux/theme-utils';

export default ({
  theme,
}) => {

  const {
    spacing,
    palette,
  } = theme;

  return {
    default: {
      ribbon: {
        backgroundColor: palette.grey12,
        ...cssSides('padding', Side.Y, gu2px(2, spacing)),
        boxSizing: 'border-box',
      },
      header: {
        ...cssSides('padding', Side.X, gu2px(1, spacing)),
      },
      actions: {
        ...cssSides('padding', Side.X, gu2px(1, spacing)),
        flex: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexDirection: 'column-reverse',
        paddingTop: gu2px(1, spacing),
      },
      decline: {
        paddingTop: gu2px(2, spacing),
      },
      buttons: {
        whiteSpace: 'nowrap',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
      },
      spacer: {
        width: gu2px(1, spacing),
      },
    },
    tablet: {
      actions: {
        flexDirection: 'row',
        paddingTop: 0,
      },
      decline: {
        paddingRight: gu2px(2, spacing),
        paddingTop: 0,
      },
      buttons: {
        flexWrap: 'nowrap',
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/presentation/components/privacy-ribbon/PrivacyRibbon.stylesheet.js